<template>
  <div class="nav">
    <img @click="$router.back()" src="../image/黑色返回@3x.png" alt="" />
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style lang="scss" scoped>
.nav {
  height: 2.2rem;
  line-height: 2.2rem;
  display: flex;
  box-sizing: border-box;
  border-bottom: 1px solid #eeeeee;
  position: relative;
  background-color: #fff;
  img {
    position: absolute;
    width: .45rem;
    height: .85rem;
    border: .6rem solid #fff;
    margin: 0 0.2rem;
  }
  .title {
    margin: auto;
    font-size: 0.95rem;
    color: #333;
    font-weight: bold;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/nav.vue